import { SalesItemRecord } from '@navio/nsdk';
import { formatCurrencyAmount } from 'noddi-util';

interface Props {
  genericItems: SalesItemRecord[];
}

/** Offer-level items (e.g. mounting) listed above a tire card's total, so the total matches what the customer pays. */
export const GenericItemPriceLines = ({ genericItems }: Props) =>
  genericItems.map(({ id, name, price }) => (
    <div className='flex justify-between gap-4' key={id}>
      <span className='text-sm'>{name}</span>
      <span>{formatCurrencyAmount({ money: price.priceGross, decimals: 0 })}</span>
    </div>
  ));
